{
  "success": {
    "example-with-variable": "This is an example with this {{__variable__}} value",
    "bitly-connect": "Great, your bitly account has been linked with the profile {{__variable__}}",
    "bitly-disconnect": "Okay, your bitly account has been disconnected.",
    "trial-extended": "Great! We’ve extended your free trial.",
    "trial-pro-started": "Nice! The trial started successfully!",
    "connection": "{{__variable__}}",
    "email-verification-success": "Your email address has been verified! Thank you for using Buffer",
    "email-update-success": " Your email has been successfully updated!"
  },
  "error": {
    "connection": "{{__variable__}}",
    "connection-instagram-wrong-account": "Oh, sorry! You're logged in on Instagram as {{__variable__}}. Could you log out on Instagram and try again?",
    "bitly-connect": "{{__variable__}}",
    "bitly-disconnect": "{{__variable__}}",
    "trial-extended": "{{__variable__}}",
    "trial-already-extended": "Oops, it seems you already extended your trial once.",
    "trial-extension-not-available": "Oops, it seems you might not be eligible for a trial extension.",
    "trial-pro-fail-started": "Oops, it seems there was an error starting a Pro Trial",
    "trial-fail-started": "Oops, it seems there was an error starting the trial: {{__variable__}}",
    "email-verification-error": "We were not able to verify your email. Your verification link may have expired"
  }
}
